import{VIEWER_REPORT_METER_MONTH_MODEL_LIST, VIEWER_REPORT_METER_MONTH_SEARCH, VIEWER_REPORT_METER_MONTH_PAGINATION,
    VIEWER_REPORT_METER_MONTH_DROP_DOWN_SEARCH_TYPE,VIEWER_REPORT_METER_MONTH_DROP_DOWN_SEARCH_SOURCE}from './actionType'

export const setModelDeviceListToState = (payload) => ({
    type: VIEWER_REPORT_METER_MONTH_MODEL_LIST,
    payload
})

export const setSearchToState = (payload) => ({
    type: VIEWER_REPORT_METER_MONTH_SEARCH,
    payload
})
export const setPaginationToState = (payload) => ({
    type: VIEWER_REPORT_METER_MONTH_PAGINATION,
    payload
})

export const setDropDownSearchType = (payload) => ({
    type: VIEWER_REPORT_METER_MONTH_DROP_DOWN_SEARCH_TYPE,
    payload
})

export const setDropDownSearchDataSource = (payload) => ({
    type: VIEWER_REPORT_METER_MONTH_DROP_DOWN_SEARCH_SOURCE,
    payload
})